import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import { varianceAccept, setVarianceActive } from '../../api'
import {
  fetchPrintSelected,
  rerender,
} from '../../store/actions'
import DashedLink from '../DashedLink'
import HOC from '../PrintVarianceComponent/HOC'
import './index.css'


/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const ModalOrderInfo = ({
                          data,
                          checkedRows,
                          setFilterType,
                          fetchPrintSelected,
                          order,
                          rerender,
                          render,
                          filterType,
                            acceptHundler,
                        }) => {
  const dataForPrint = (data.filter(row => Object.keys(checkedRows).includes(row.partnum)))
  const acceptedData = Object.keys(checkedRows)
  const [ isShowSelected, setIsShowSelected ] = useState(false)
    const [activeCheckedRows, setActiveCheckedRows] = useState([]) ;
    const [acceptedCheckedRows, setAcceptedCheckedRows] = useState([]) ;

    useEffect(() => {
        const localActiveRows = [];
        const localAcceptedRows = [];

        acceptedData.forEach((el) => {
            const row = data.find(dataItem => dataItem.partnum === el);
            if(row.status === 'accepted') {
                localAcceptedRows.push(el);
            } else if (row.status === 'active'){
                localActiveRows.push(el);
            } else {
                return;
            }
        });

        setAcceptedCheckedRows(localAcceptedRows);
        setActiveCheckedRows(localActiveRows);
    }, [data, acceptedData]);
    const preventWrapper = (e) => {
    e.stopPropagation()
  }
  const handleClick = async () => {
    try {
      await varianceAccept(order.id, activeCheckedRows);
        acceptHundler([...activeCheckedRows]);

        await rerender(!render);
        setActiveCheckedRows([]);
        window.location.reload()

    } catch (error) {
      console.log(error);
    }
  };

  const handleSetActive = async () => {
      try {
          await setVarianceActive(order.id, acceptedCheckedRows);
          acceptHundler([...acceptedCheckedRows]);

          await rerender(!render);
          setAcceptedCheckedRows([]);
          window.location.reload()
      } catch (error) {
          console.log(error);
      }
  };

  const componentRef = React.useRef()

  let handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  return (
    <div className={'container--orderInfo'}>
      <div className='container--orderInfo__wrapper' onClick={preventWrapper}>
          {activeCheckedRows.length > 0 && (
              <DashedLink onClick={() => handleClick()} name="Accept Counts " />
          )}
          {acceptedCheckedRows.length > 0 && (
              <DashedLink onClick={() => handleSetActive()} name="Set Active" />
          )}

          <div
          className="order-info-header__print"
          name={'Print Variance Report'}>
          <div>
            <DashedLink name={'Print Selected'} onClick={handlePrint} />
            <div style={{ display: 'none' }}><HOC data={dataForPrint} ref={componentRef} /></div>
          </div>
        </div>
        <DashedLink
          onClick={() => {
            setIsShowSelected(!isShowSelected)
            setFilterType(!isShowSelected ? 'selected' : 'all')
          }}
          name={isShowSelected ? 'Show All' : 'Show Only Selected'}
        />
      </div>
    </div>
  )
}
const mapStateToProps = ({ data: { render } }) => ({ render })
const mapDispatchToProps = ({ fetchPrintSelected, rerender })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalOrderInfo)


